























































import { Component, Vue } from "vue-property-decorator";
import { User } from "@/components/User";
import { APP_URL } from "@/common/http";

@Component
export default class ImageCategory extends Vue {
  appUrl:string = APP_URL;
  ImageCategories:any[] = [];

  get User() : User {
    return this.$store.getters.User;
  };

  get language() : string {
    return this.User.Language;
  };

  async fetchImageCategories() {
    try {
      if (this.ImageCategories && this.ImageCategories.length>0) return;
      let data = await this.User.requestResource('codelist/image_categories');
      this.ImageCategories = data.map((d) => {
        return {
          code: d.code,
          name_th: d.name,
          name_en: d.name_en,
          name_zh: d.name_zh,
          thumb: d.thumb,
          images: d.images
        };
      });
    } catch (error) {
    }
  };

  created() {
    this.fetchImageCategories();
  }

  async gotoImageCategory(category) {
    this.$emit('changeMe',{
      menu: {
        name: 'image_archive',
        title: 'imageArchive'
      },
      data: category
    });
  }

  closeMe() {
    this.$emit('closeRightToc');
  }
}
